import React from 'react';
import BackButton from './BackButton.js';

function InConstruction() {
    return (
        <div className="construction-container">
                <div className="">
                    <h1>In Construction</h1>
                    <p style={{ color: '#000'}}>This component is still under development.</p>
                </div>
            <BackButton className="align-button" />
        </div>
    );
};

export default InConstruction;